import { useState } from 'react'
import './navbar.css'
import {Link} from 'react-router-dom'

function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    window.onscroll = () =>{
        setScrolled(window.pageYOffset === 0 ? false : true);
        return () => window.onscroll = null;
    }
    console.log(scrolled);
    return (
        <div className={scrolled ? 'navbar scrolled' : 'navbar'}>
            <div className='container'>
                <div className='left'>
                 <Link to='/' className='link'> <h1>Exqui <span> Real Estates </span></h1></Link>
                </div>
                <div className='center'>           
                <Link to='/' className='link'> <span className='nav--span'>Home</span></Link>
               <Link to='/contact' className='link'><span className='nav--span'>Contact</span></Link>
               <Link to='/blog' className='link'><span className='nav--span'>Blog</span></Link>
               <Link to='/others' className='link'><span className='nav--span'>Others</span></Link> 
               </div>

                <div className='right' >
                 <i class="fas fa-house-user fa-2x"></i>
                 <span>Nakuru</span>
                 <div className='menu--others'>
                 <i class="fas fa-sort-down fa-2x"></i>
                 <div className='menu-others-item'>
                    <a href='https://web.facebook.com/Exquisite-services-100825231775219' target='_blank' className='link'><span><i class="fab fa-facebook-square fa-2x"></i></span></a> 
                   <span><i class="fab fa-twitter-square fa-2x"></i></span>
                    <a href='https://www.linkedin.com/in/arthur-mwangi-7a80761bb/' target='_blank' className='link'><span><i class="fab fa-linkedin fa-2x"></i></span></a> <br></br>
                     <a href='https://www.instagram.com/ngigearthur/' target='_blank' className='link'><span><i class="fab fa-instagram-square fa-2x"></i></span></a>
                 </div>
                 </div>
                </div>
                <div className='mobile-toggle' onClick={() => setOpen(true)}>
                    <i class="fas fa-bars fa-2x"></i>
                </div>
                {open && (
                  <div className='mobile-menu'> 
                <i class="far fa-times-circle fa-2x" onClick={() => setOpen(false)} ></i>          
                <Link to='/' className='link'> <span className='mobile--span' onClick={() => setOpen(false)}>Home</span></Link>
               <Link to='/contact' className='link'><span className='mobile--span' onClick={() => setOpen(false)}>Contact</span></Link>
               <Link to='/blog' className='link'><span className='mobile--span' onClick={() => setOpen(false)}>Blog</span></Link>
               <Link to='/others' className='link'><span className='mobile--span' onClick={() => setOpen(false)}>Others</span></Link> 
               </div>
                )}
                
            </div>
        </div>
    )
}

export default Navbar
